<adaa-adaa4-stepper [current]="1" />

<div class="page-head">
    <div>
        <h1 class="page-title">{{ "adaa4.notifications_title" | translate }}</h1>
        <p class="page-eyebrow">{{ "adaa4.notifications_subtitle" | translate }}</p>
    </div>
    <a class="btn btn--ghost btn--sm" routerLink="/homepage">
        <span class="btn-arrow btn-arrow--back" aria-hidden="true">←</span>
        {{ "navigation.home" | translate }}
    </a>
</div>

<section class="panel">
    <div class="toolbar">
        <div class="filters" role="group" [attr.aria-label]="'adaa4.action_type' | translate">
            <button
                type="button"
                class="filter-chip"
                [class.is-active]="!notifications.action()"
                [attr.aria-pressed]="!notifications.action()"
                (click)="notifications.setAction(null)"
            >
                {{ "common.form.label.all" | translate }}
            </button>
            @for (action of actionFilters; track action) {
                <button
                    type="button"
                    class="filter-chip"
                    [class.is-active]="notifications.action() === action"
                    [attr.aria-pressed]="notifications.action() === action"
                    (click)="notifications.setAction(action)"
                >
                    {{ "adaa4.action_" + action | translate }}
                </button>
            }
        </div>
        <label class="search">
            <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                aria-hidden="true"
            >
                <circle cx="11" cy="11" r="7" />
                <path d="m20 20-3.5-3.5" />
            </svg>
            <input
                type="search"
                [placeholder]="'adaa4.search_object_or_entity' | translate"
                [value]="notifications.search()"
                (input)="onSearch($any($event.target).value)"
            />
        </label>
    </div>

    <div class="wf-table" role="table" [attr.aria-label]="'adaa4.notifications_title' | translate">
        <div class="wf-row wf-head" role="row">
            <span class="wf-cell" role="columnheader">{{ "adaa4.sn" | translate }}</span>
            <span class="wf-cell" role="columnheader">{{ "adaa4.action_type" | translate }}</span>
            <span class="wf-cell" role="columnheader">{{ "adaa4.start_date" | translate }}</span>
            <span class="wf-cell" role="columnheader">{{ "adaa4.object_name" | translate }}</span>
            <span class="wf-cell" role="columnheader">{{ "adaa4.object_type" | translate }}</span>
            <span class="wf-cell" role="columnheader">{{ "adaa4.pending_days" | translate }}</span>
            <span class="wf-cell" role="columnheader">{{ "common.form.label.entity" | translate }}</span>
            <span class="wf-cell" role="columnheader">{{ "adaa4.actions" | translate }}</span>
        </div>

        <div class="wf-body">
            @for (notification of notifications.visibleItems(); track notification.id; let index = $index) {
                @let type = notifications.actionType(notification);
                <div class="wf-row" role="row" (click)="open(notification)">
                    <span class="wf-cell wf-sn" role="cell">{{ index + 1 }}</span>
                    <span class="wf-cell" role="cell" [attr.data-label]="'adaa4.action_type' | translate">
                        <span class="chip" [class]="'chip--' + type">
                            @if (type === "other") {
                                {{ AdaaHelper.getItemValueByToken(notification, "itemTypeName") }}
                            } @else {
                                {{ "adaa4.action_" + type | translate }}
                            }
                        </span>
                    </span>
                    <span class="wf-cell" role="cell" [attr.data-label]="'adaa4.start_date' | translate">
                        {{ startDate(notification) }}
                    </span>
                    <span class="wf-cell wf-name" role="cell">
                        <a
                            [routerLink]="['/homepage/notifications', notification.id]"
                            [class.is-unread]="notification.isRead === 'N'"
                            (click)="$event.stopPropagation()"
                        >
                            {{ name(notification) }}
                        </a>
                    </span>
                    <span class="wf-cell" role="cell" [attr.data-label]="'adaa4.object_type' | translate">
                        {{ AdaaHelper.getItemValueByToken(notification, "itemTypeName") }}
                    </span>
                    <span class="wf-cell" role="cell" [attr.data-label]="'adaa4.pending_days' | translate">
                        @if (notifications.isPending(notification)) {
                            @let days = notifications.pendingDays(notification);
                            <span class="pending" [class]="'pending--' + pendingTone(days)"> {{ days }} {{ "adaa4.days" | translate }} </span>
                        } @else {
                            <span class="muted">-</span>
                        }
                    </span>
                    <span class="wf-cell" role="cell" [attr.data-label]="'common.form.label.entity' | translate">
                        {{ AdaaHelper.getItemValueByToken(notification, "entityName") || "-" }}
                    </span>
                    <span class="wf-cell wf-actions" role="cell">
                        <a
                            class="icon-btn"
                            [routerLink]="['/homepage/notifications', notification.id]"
                            [attr.aria-label]="'adaa4.view_details' | translate"
                            (click)="$event.stopPropagation()"
                        >
                            <svg
                                viewBox="0 0 24 24"
                                width="20"
                                height="20"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.7"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                aria-hidden="true"
                            >
                                <circle cx="12" cy="12" r="3" />
                                <path
                                    d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z"
                                />
                            </svg>
                        </a>
                    </span>
                </div>
            } @empty {
                @if (!notifications.loading()) {
                    <p class="wf-empty">{{ "communication.no_notifications" | translate }}</p>
                }
            }
        </div>
    </div>

    @if (notifications.hasMore()) {
        <div class="more">
            <button type="button" class="btn btn--ghost btn--sm" [disabled]="notifications.loading()" (click)="notifications.loadMore()">
                {{ "communication.show_more_messages" | translate }}
            </button>
        </div>
    }
</section>
